export default __webpack_public_path__ + "static/media/041-bathroom.b280f4a7.svg";